<script>
    export let data
    export let formID = "Contact";

    import { api } from "@/services/contact";
    import LoadingDots from "@/components/LoadingDots.svelte";
    import Input from "@/components/form/Input.svelte";
    import Textarea from "@/components/form/Textarea.svelte";
    import { translate } from "@/lib/utils"

    import { onDestroy, onMount, createEventDispatcher } from "svelte";
    import { errors } from "@/stores/error";
    import { set } from "lodash"
    import Checkbox from "./form/Checkbox.svelte";

    let loading = false;

    const dispatch = createEventDispatcher();

    onMount(() => {
        dispatch("loaded")
    })

    onDestroy(() => {
        errors.update((errors) => set(errors, formID, []));
    });

    const submit = async (event) => {
        loading = true;
        const data = new FormData(event.target);

        await api.submit(data, { formID: formID, headers: {
                    "Content-Type": "multipart/form-data",
                }, })
            .finally(() => {
                event?.target?.reset()
                loading = false;
            })
    }
</script>

<form on:submit|preventDefault={submit}>
    <input type="hidden" name="form_id" value={formID}/>

    <Input
        name="first_name"
        placeholder={
            translate({
                'de': 'Vorname',
                'en': 'Firstname',
            })
        }
        type="text"
        {formID}
        containerClass="w-full my-3"
        inputClass=""
    />

    <Input
        name="last_name"
        placeholder={
            translate({
                'de': 'Nachname',
                'en': 'Lastname',
            })
        }
        type="text"
        {formID}
        containerClass="w-full my-3"
        inputClass=""
    />

    <Input
        name="email"
        placeholder={
            translate({
                'de': 'E-Mail Adresse',
                'en': 'E-Mail Address',
            })
        }
        type="text"
        {formID}
        containerClass="w-full my-3"
        inputClass=""
    />

    <Textarea 
        name="message"
        rows="8"
        placeholder={
            translate({
                'de': 'Deine Nachricht',
                'en': 'Your Message',
            })
        }
        {formID}
        inputClass=""/>

    <Checkbox
        name="privacy"
        containerClass="mt-2 text-sm"
        {formID}
        option={
            translate({
                'de': 'Mit dem Einreichen dieses Formulars erkläre ich mich damit einverstanden, dass meine Daten zur Beantwortung meiner Anfrage elektronisch erhoben werden. Ich habe die Datenschutzerklärung zur Kenntnis genommen.',
                'en': 'By submitting this form, I agree that my data will be collected electronically for the purpose of responding to my inquiry. I have taken note of the privacy policy.',
            })
        }
    />
    
    <div class="mt-2">
        <button type="submit" class="button primary !text-white">
            {#if loading}
                <LoadingDots/>
            {:else}
                <span>{translate({
                    'de': 'Absenden',
                    'en': 'Send'
                })}</span>
            {/if}
        </button>
    </div>
</form>